module.exports = __webpack_public_path__ + "img/37.8b01658a.jpg";